import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  actionsButton: {
    border: 'none',
    outline: 'none',
    backgroundColor: 'transparent',

    '& svg': {
      marginBottom: -8
    }
  }
}))
